// extracted by mini-css-extract-plugin
export var box = "Loader-module--box--30888";
export var box_md = "Loader-module--box_md--d177f";
export var box_xmd = "Loader-module--box_xmd--2a956";
export var box_flex = "Loader-module--box_flex--e9060";
export var box_lg = "Loader-module--box_lg--340c0";
export var box_sm = "Loader-module--box_sm--4054c";
export var box_outer = "Loader-module--box_outer--adb55";
export var box_whiteBg = "Loader-module--box_white-bg--caa60";
export var box_noMarginBottom = "Loader-module--box_no-margin-bottom--4df51";
export var box_noPadding = "Loader-module--box_no-padding--1a13b";
export var box_outerGray = "Loader-module--box_outer-gray--faba5";
export var box_dark = "Loader-module--box_dark--8e5cc";
export var box_zIndex = "Loader-module--box_z-index--a6f78";
export var box_zIndex6 = "Loader-module--box_z-index-6--fbf0e";
export var box_eventsWithLine = "Loader-module--box_events-with-line--78c6d";
export var box_featuresAo = "Loader-module--box_features-ao--93140";
export var box_verticalPaddings = "Loader-module--box_vertical-paddings--272b0";
export var clearP = "Loader-module--clearP--f3abf";
export var clearP_vc = "Loader-module--clearP_vc--db90a";
export var wrap = "Loader-module--wrap--034d7";
export var fullHeight = "Loader-module--fullHeight--c18af";
export var big = "Loader-module--big--c46c4";
export var loader = "Loader-module--loader--87b9f";
export var item = "Loader-module--item--4d4dc";
export var page = "Loader-module--page--8173c";
export var block = "Loader-module--block--2d0bc";
export var button = "Loader-module--button--996f8";
export var formField = "Loader-module--formField--9c18e";
export var formFieldRacing = "Loader-module--formFieldRacing--90c8d";
export var white = "Loader-module--white--1efe4";
export var ldsRing = "Loader-module--lds-ring--c9cdd";
export var fadeInAnimation = "Loader-module--fadeInAnimation--67139";
export var placeHolderShimmer = "Loader-module--placeHolderShimmer--03d1a";